const InfoRow = ({ title, value }) => {
    return (
        <div className="flex flex-row w-full py-2 justify-start items-center gap-2">
            <div className="text-gray-600">{title}</div>
            <div className="text-gray-900">{value ?? "n/a"}</div>
        </div>
    );
};

const DeviceInfo = ({info}) => {
    return (
        <div className="border-y border-gray-800">
        <InfoRow title="Serial number:" value={info?.serialNumber} />
        <InfoRow title="Firmware version:" value={info?.firmware} />
        <InfoRow title="Codentify:" value={info?.codentify} />
    </div>
    )
}

export default DeviceInfo;